/**
 * @author Sarthak Sharma.
 * @since 02-01-2024.
 * @type {string} auth action types.
 */

export const SET_MOBILE_NO = '[AUTH] SET_MOBILE_NO';
export const SET_USERNAME = '[AUTH] SET_USERNAME';
export const SET_LOADING = '[AUTH] SET_LOADING';
export const SET_OTP_LOGIN = '[AUTH] SET_LOGIN';
export const SET_USER_ID = '[AUTH] SET_USER_ID';
export const SET_OTP_VERIFICATION = '[AUTH] SET_OTP_VERIFICATION';

